import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "~/components/helpCenterModal/styles";
import Modal from "~/components/ui/Modal";
import { useMediaQuery } from "~/hooks/useMediaQuery";
import { tutorials } from "~/constants/videoTutorial";
import VideoPlayerSection from "~/pages/dashboard/components/VideoPlayerSection";
import VideoList from "~/pages/dashboard/components/VideoList";

type Props = {
  isShowing: boolean;
  hide: () => void;
  path: string;
};

export const HelpCenterModal = ({ isShowing, path, hide }: Props) => {
  const { t } = useTranslation();
  const isLaptop = useMediaQuery("desktop");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  return (
    <Modal
      id="help-center"
      isShowing={isShowing}
      hide={() => hide()}
      minWidth={isLaptop ? "50%" : "80%"}>
      <S.Container>
        <S.Header>{t("home.video_component_title")}</S.Header>
        {/* Same player and list as the dashboard's Quick Walkthrough. */}
        <S.Videos>
          <S.PlayerBox>
            <VideoPlayerSection
              videoRef={videoRef}
              isPlaying={isPlaying}
              isOverlayVisible
              selectedTutorial={tutorials[selectedIndex]}
              setIsPlaying={setIsPlaying}
            />
          </S.PlayerBox>
          <S.ListBox>
            <VideoList
              tutorials={tutorials}
              selectedIndex={selectedIndex}
              onSelect={(index) => {
                setSelectedIndex(index);
                setIsPlaying(false);
              }}
            />
          </S.ListBox>
        </S.Videos>
        <S.MoreHelpText>
          {t("settings.need_more_help")}
          <S.MoreHelpLink href={path} target="_blank" rel="noopener noreferrer">
            {t("settings.help_center")}
          </S.MoreHelpLink>
        </S.MoreHelpText>
      </S.Container>
    </Modal>
  );
};
